<template>
  <div class="connector-info-card" :style="`--card-color: ${color};`">
    <div class="connector-info-card-content">
      <div>
        <div
          v-if="title || $slots['title-tooltip']"
          class="connector-info-card-content-title"
        >
          {{ title }}
          <template v-if="$slots['title-tooltip']">
            <i
              :id="'connector-info-card-content-tooltip-' + id"
              class="fa-solid fa-circle-info"
            />
            <b-tooltip
              :target="'connector-info-card-content-tooltip-' + id"
              custom-class="connector-info-card-content-tooltip"
            >
              <slot name="title-tooltip"></slot>
            </b-tooltip>
          </template>
        </div>
        <div class="connector-info-card-content-value">{{ value }}</div>
      </div>
      <div
        v-if="icon"
        class="connector-info-card-content-icon"
      >
        <i :class="icon" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    value: {
      type: [String, Number],
      default: "",
    },
    icon: {
      type: String,
      default: "",
    },
    color: {
      type: String,
      default: "black",
    },
  },
  data() {
    return {
      id: null,
    };
  },
  created() {
    this.id = this._uid;
  },
};
</script>

<style lang="css" scoped>
.connector-info-card {
  background-color: var(--card-color, black);
  border: 1px solid lightgray;
  border-radius: 0.5em;
  padding-left: 0.25em;
  overflow: hidden;
}
.connector-info-card-content {
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: white;
  border-top-left-radius: 0.25em;
  border-bottom-left-radius: 0.25em;
  padding: 0.5em 0.75em;
  text-align: left;
}
.connector-info-card-content > *:first-child {
  flex: 1;
}
.connector-info-card-content-title {
  color: grey;
  font-size: 0.6em;
  text-transform: uppercase;
}
.connector-info-card-content-value {
  display: flex;
  align-items: center;
  color: #04546a;
  font-size: 1.5em;
  font-weight: bold;
}
.connector-info-card-content-icon {
  display: flex;
  align-items: center;
  font-size: 1lh;
  color: var(--card-color, black);
  opacity: 0.4;
}
</style>
